export const legalDescription = (
  <div>
    <p>
      Dynamic Translation utilizes Amazon Translate to support the efficiency of
      case resolution. Automated machine-generated AI translations are not
      perfect and may contain errors, inaccuracies, or misstatements. The
      translation provided should not be:
    </p>
    <ol>
      <li>Used as a replacement for human professionals translations.</li>
      <li>Considered an exact, official, or authoritative.</li>
    </ol>
    <p>
      This notification serves as a reminder of the inherent limitations of
      automated technologies. Dynamic Translation provides no warranty of its
      accuracy, reliability, or correctness.
    </p>
  </div>
);
